import { createContext, useContext } from 'react';
import { LoadedRemote } from 'mfe/manifest';

type RemotesState = {
  status: 'loading' | 'ready' | 'error';
  remotes: LoadedRemote[];
};

// Valeur par defaut "ready sans remote" : tout composant rendu hors
// RemotesProvider (tests unitaires notamment) se comporte comme si le
// manifeste etait vide, sans stub a fournir.
const RemotesContext = createContext<RemotesState>({ status: 'ready', remotes: [] });

function useRemotes() {
  return useContext(RemotesContext);
}

export { RemotesContext, useRemotes };
export type { RemotesState };
